"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityManagerFactory = void 0;
var tslib_1 = require("tslib");
var EntityManager_1 = require("./EntityManager");
var message = tslib_1.__importStar(require("./message"));
var connector_1 = require("./connector");
var util_1 = require("./util");
var intersection_1 = require("./intersection");
var metamodel_1 = require("./metamodel");
var CONNECTED = Symbol('Connected');
var EntityManagerFactory = /** @class */ (function (_super) {
    tslib_1.__extends(EntityManagerFactory, _super);
    /**
     * Creates a new EntityManagerFactory connected to the given destination
     * @param [options] The destination to connect with, or an options object
     * @param [options.host] The destination to connect with
     * @param [options.port=80|443] The optional destination port to connect with
     * @param [options.secure=false] <code>true</code> To use a secure ssl encrypted connection
     * @param [options.basePath="/v1"] The base path of the api
     * @param [options.schema=null] The serialized schema as json used to initialize the metamodel
     * @param [options.tokenStorage] The tokenStorage which should be used by this emf
     * @param [options.tokenStorageFactory] The tokenStorage factory implementation which
     * should be used for token storage
     * @param [options.staleness=60] The maximum staleness of objects that are acceptable while reading cached
     * data
     */
    function EntityManagerFactory(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.connection = null;
        _this.metamodel = _this.createMetamodel();
        _this.code = new intersection_1.Code(_this.metamodel, _this);
        _this.tokenStorageFactory = intersection_1.TokenStorage.WEB_STORAGE || intersection_1.TokenStorage.GLOBAL;
        _this.tokenStorage = null;
        _this.staleness = null;
        _this.connectData = null;
        var opt = typeof options === 'string' ? { host: options } : options || {};
        _this.configure(opt);
        var isReady = true;
        var ready = new Promise(function (success) {
            _this[CONNECTED] = success;
        });
        if (opt.host) {
            _this.connect(opt.host, opt.port, opt.secure, opt.basePath);
        }
        else {
            isReady = false;
        }
        if (!_this.tokenStorage) {
            isReady = false;
            ready = ready
                .then(function () { return _this.tokenStorageFactory.create(_this.connection.origin); })
                .then(function (tokenStorage) {
                _this.tokenStorage = tokenStorage;
            });
        }
        if (opt.schema) {
            _this.connectData = opt;
            _this.metamodel.init(opt.schema);
        }
        else {
            isReady = false;
            ready = ready.then(function () {
                var _a;
                var msg = new message.Connect();
                msg.withCredentials = true; // used for registered devices
                if (_this.staleness === 0) {
                    msg.noCache();
                }
                if ((_a = _this.tokenStorage) === null || _a === void 0 ? void 0 : _a.token) {
                    // disable client cache on the connect resource if we are authenticated
                    msg.addQueryString('BCB');
                }
                return _this.send(msg);
            }).then(function (response) {
                _this.connectData = response.entity;
                if (_this.staleness === null) {
                    _this.staleness = _this.connectData.bloomFilterRefresh || 60;
                }
                if (!_this.metamodel.isInitialized) {
                    _this.metamodel.init(_this.connectData.schema);
                }
                _this.tokenStorage.update(_this.connectData.token);
            });
        }
        if (!isReady) {
            _this.withLock(function () { return ready; }, true);
        }
        return _this;
    }
    /**
     * Apply additional configurations to this EntityManagerFactory
     * @param options The additional configuration options
     * @param [options.tokenStorage] The tokenStorage which should be used by this emf
     * @param [options.tokenStorageFactory] The tokenStorage factory implementation which
     * should be used for token storage
     * @param [options.staleness=60] The maximum staleness of objects that are acceptable while reading cached
     * data, <code>0</code> to always bypass the browser cache
     * @return
     */
    EntityManagerFactory.prototype.configure = function (options) {
        if (this.connection) {
            throw new Error('The EntityManagerFactory can only be configured before is is connected.');
        }
        if (options.tokenStorage) {
            this.tokenStorage = options.tokenStorage;
        }
        if (options.tokenStorageFactory) {
            this.tokenStorageFactory = options.tokenStorageFactory;
        }
        if (options.staleness !== undefined) {
            this.staleness = options.staleness;
        }
    };
    EntityManagerFactory.prototype.connect = function (hostOrApp, port, secure, basePath) {
        if (this.connection) {
            throw new Error('The EntityManagerFactory is already connected.');
        }
        if (typeof port === 'boolean') {
            return this.connect(hostOrApp, 0, port, secure);
        }
        this.connection = connector_1.Connector.create(hostOrApp, port, secure, basePath);
        this[CONNECTED]();
        return this.ready();
    };
    /**
     * Creates a new Metamodel instance, which is not connected
     * @return A new Metamodel instance
     */
    EntityManagerFactory.prototype.createMetamodel = function () {
        return new metamodel_1.Metamodel(this);
    };
    /**
     * Create a new application-managed EntityManager.
     *
     * @param useSharedTokenStorage The token storage to persist the authorization token, or
     * <code>true</code> To use the shared token storage of the emf.
     * <code>false</code> To use a instance based storage.
     *
     * @return a new entityManager
     */
    EntityManagerFactory.prototype.createEntityManager = function (useSharedTokenStorage) {
        var _this = this;
        var em = new EntityManager_1.EntityManager(this);
        if (this.isReady) {
            em.connected(useSharedTokenStorage);
        }
        else {
            em.withLock(function () { return _this.ready().then(function () {
                em.connected(useSharedTokenStorage);
            }); }, true);
        }
        return em;
    };
    EntityManagerFactory.prototype.send = function (msg) {
        if (!msg.tokenStorage()) {
            msg.tokenStorage(this.tokenStorage);
        }
        return this.connection.send(msg);
    };
    return EntityManagerFactory;
}(util_1.Lockable));
exports.EntityManagerFactory = EntityManagerFactory;
//# sourceMappingURL=data:application/json;base64,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